module.exports = __webpack_public_path__ + "img/footer_logo.4b3368c1.svg";